import { useState } from "react";
import "./ContactForm.scss";

import { Col, Container, Row } from "react-bootstrap";

import { Link } from "react-router-dom";

const FORM_ENDPOINT = "https://public.herotofu.com/v1/0cf961e0-41f0-11ed-9b17-6fdf7f94f506"; // TODO - fill on the later step

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = () => {
    setTimeout(() => {
      setSubmitted(true);
    }, 100);
  };

  if (submitted) {
    return (
      <div className="contact__form navbar-text">
        <h2>Thank you!</h2>
        <div>I'll be in touch soon.</div>
        <Link className="nav__link"  to="/"> <button className="vvd">
              <span>Go Back Home</span>
            </button>
            </Link>
      </div>
    );
  }


  return (
    <section className="contact" id="connect">
      <Container>
          <Col md={10} className="contact__column">
            <h2 className="contact__header">Get In Touch</h2>
            <form className="contact__form"
              action={FORM_ENDPOINT}
              onSubmit={handleSubmit}
              method="POST"
              target="_blank"
            >
              <Row>
                <Col sm={6} className="px-2">
                  <input type="text" placeholder="Your name" name="name" required />
                </Col>
                <Col sm={6} className="px-2">
                  <input type="email" placeholder="Email" name="email" required />
                </Col>
                <Col>
                  <textarea placeholder="Your message" name="message" required />
                  <button type="submit">
                    <span>Send</span>
                  </button>
                </Col>
              </Row>
            </form>
          </Col>
      </Container>
    </section>
  );
};

export default ContactForm;